import { QuestionTypes } from '@showbie-socrative/socrative-utils';

import { QuestionTypes as AnalyticsQuestionTypes } from '~analytics/types';

/**
 * Maps the raw socrative-utils question type wire code to the analytics
 * vocabulary. Shared by every event that reports a question type, so the
 * mapping can't drift between events. Returns null for types with no
 * analytics representation yet (e.g. Matching).
 */
export function mapQuestionType(
  questionType: QuestionTypes | string
): AnalyticsQuestionTypes | null {
  switch (questionType) {
    case QuestionTypes.TrueFalse:
      return AnalyticsQuestionTypes.TrueFalse;
    case QuestionTypes.MultipleChoice:
      return AnalyticsQuestionTypes.MultipleChoice;
    case QuestionTypes.FreeResponse:
      return AnalyticsQuestionTypes.ShortAnswer;
    case QuestionTypes.Numeric:
      return AnalyticsQuestionTypes.Numeric;
    default:
      return null;
  }
}
